export class CurrLotteryModel {
    LotteryCode: string;
    LotteryName: string;
    LotteryTypeCode: string;
    LotteryTypeName: string;
    OpenLength: number;
    NumLength: number;
    IsAuto: boolean;
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
    RewardUp: number;
    RewardDown: number;
    BlockTime: number;
    //玩法类别
    PlayMode: PlayModeModel;
    //玩法类别组
    PlayModes: PlayModeModel[];
    PlayDetail: PlayDetailModel;
}

export class CachedModel {
    PlayMode: StorageLottery;
    PlayDetail: PlayDetailModel;
}

export class StorageLottery {
    LotteryCode: string;
    LotteryName: string;
}
export class PlayModeModel {
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
    LotteryCode: string;
    State: string;
    SerialsID: number;
    IsSelect: boolean;
    LotteryPlayModeTypeCode: number;
    PlayModeType?: number;
    //玩法细则组
    PlayDetails: PlayDetailModel[];
}

export class PlayDetailModel {
    LotteryPlayDetailCode: string;
    LotteryPlayDetailName: string;
    LotteryPlayModeCode: string;
    State: string;
    SerialsID: number;
    AlgorithmCode: string;
    CardinalMoney: number;
    Modulus: number;
    CardinalMoney1: number;
    Modulus1: number;
    LimitBet: number;
    IsRewardFixed: boolean;
    IsAttached: boolean;
    PlayGroup: string;
    Algorithm: AlgorithmModel;
    PlayDetailAttacheds: PlayDetailAttachedModel[];
}

export class PlayDetailAttachedModel {
    NumKey: string;
    LotteryPlayDetailCode: string;
    CardinalMoney: number;
    Modulus: number;
    SerialsID: number;
}


export class AlgorithmModel {
    AlgorithmCode: string;
    AlgorithmName: string;
    SerialsID: number;
    AlgorithmTypeCode: string;
    BetNumLength: number;
    TipInfo: string;
    PickExample: string;
    AlgorithmType: AlgorithmTypeModel;
}


export class AlgorithmTypeModel {
    AlgorithmTypeCode: string;
    AlgorithmTypeName: string;
    State: string;
    LotteryTypeCode: string;
    SerialsID: number;
    PickMode: string;
    CanCommonRan: string;
}

export class IssueModel {
    BeginTime: Date;
    BeginTime1: Date;
    Crossdays: boolean;
    EndTime: Date;
    EndTime1: Date;
    IssueNo: string;
    LotteryCode: string;
    LotteryTypeCode: string;
    MaxIssue: number;
    MinIssue: number;
    NowIssueDay: Date;
    Issue: NextIssueModel;
    Frequency: number = 0;
    RemainTime: number = 0;
    Seconds: number = 0;
}

export class NextIssueModel {
    IssueNo: string = "";
    BeginTime: string = "";
    EndTime: string = "";
    BeginTime1: string = "";
    EndTime1: string = "";
    LotteryCode: string = "";
    MaxIssue: number = 0;
    MinIssue: number = 0;
    Multiple: number = 0;
    Crossdays: boolean = false;
    LotteryTypeCode: string = "";
    NowIssueDay: string = "";
    BettingSumMoney: number = 0;
}

export class BettingRecord {
    PlayerName: string;
    BillNo: string;
    GameTypeName: string;
    PlayTypeName: string;
    BetTime: string;
    BetAmount: string;
    NetAmount: string;
    GameCode: string;
    TableCode: string;
}

export class DollerAttr {
    LotteryPlayDetailName: string;
    LotteryPlayDetailCode: string;
    currLotteryPlayDetailName: string;
    BettingOdds: number;
    Modulus: number;
    CardinalMoney: number;
    check: boolean;
    extendValue?: any;
}

export class AnBetting {
    BetTotal: number;
    Position1: string;
    Position2: string;
    Position3: string;
    SerialNo: number;
    BettingNumber: string;
    BettingMoney: number;
    LotteryPlayCode: string;
    LotteryPlayDetailCode: string;
    BettingOdds: number;
    Position: string;
    Modulus: number;
    CardinalMoney: number;
    Rebate: number;
    RangeValue: number;
}

export class ChaseBetting {
    IssueNo: string;
    Multiple: number;
    PerPrice: number;
    BettingMoney: number;
}

export class ResumeOrderDetail {
    AddTime: string;
    BettingID: string;
    BettingMoney: number;
    BettingNumber: string;
    BonusMoney: number;
    BuyIssueCount: number;
    CompleteIssueCount: number;
    GraduationCount: number;
    IsChaseNo: any;
    IsStopAfterWinning: boolean;
    IssueNo: string;
    Issues: any[];
    LotteryCode: string;
    LotteryName: string;
    LotteryTypeCode: string;
    PlayName: string;
    RevocationMoney: number;
    Reward: number;
    SelectMedian: string;
    StateName: string;
    UserName: string;
    PlayCode: string;
    BettingItems: any;
    LotteryPlayModeCode: any;
    BettingItemCount: any;
    BettingInfoIssues: any;
    LotteryPlayModeName: string;
}



// WEBPACK FOOTER //
// ./src/models/betting.model.ts